import React, { ReactElement, useEffect, useMemo, useState } from 'react';
import './KodanshaProduct.scss';
import '../Series/Desktop/DesktopHeader/DesktopHeader.scss';
import KodanshaBreadCrumb from '../../KodanshaUIKit/KodanshaBreadCrumb/KodanshaBreadCrumb';
import Rating from './Rating/Rating';
import SelectProduct from './SelectProduct/SelectProduct';
import KodanshaAvailable from '../../KodanshaUIKit/KodanshaAvailable/KodanshaAvailable';
import { KodanshaNavbar } from '../../KodanshaNavbar/KodanshaNavbar';
import useLazyFetch from '../../Hooks/useLazyFetch';
import apiClient from '../../../API/InkyAPI';
import { useAtom, useAtomValue, useSetAtom } from 'jotai';
import { Product } from '../../../Models/Product';
import DesktopHeader from '../Series/Desktop/DesktopHeader/DesktopHeader';
import DesktopRating from './DesktopRating/DesktopRating';
import { useHistory, useParams } from 'react-router-dom';
import { Link } from '../../../Devon/Components/InkyLink';
import ProductPoster from '../../KodanshaUIKit/ProductPoster/ProductPoster';
import { KodanshaFooter } from '../../KodanshaFooter/KodanshaFooter';
import KodanshaSubscription from '../../KodanshaSubscription/KodanshaSubscription';
import { AccountInfoAtom, LoginStatus, LoginStatusAtom } from '../../../store/AccountStore';
import { formTheAssetGroup, mapCreators, readerReadableUrlOrDefault } from '../../../utils/utils';
import ReactGA from 'react-ga4';
import { Helmet } from 'react-helmet';
import SynopsisTab from './synopsis-tab/SynopsisTab';
import { usePurchasedType } from '../Series/usePurchasedType';
import VolumeDirect from './VolumesWheel/VolumeDirect';
import VolumesWheel from './VolumesWheel/VolumesWheel';
import { StructuredData, StructuredDataProps } from '../../../Devon/Components/StructuredData/StructuredData';
import { VariantType } from '../../../Models/CartItem';
import { KodanshaNotFound } from '../../KodanshaNotFound/KodanshaNotFound';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEdit } from '@fortawesome/free-solid-svg-icons';
import BrowseManga from '../Series/BrowseManga/BrowseManga';
import Log from '../../Services/Logger';
import { FetchSingleSeriesAtom, LoginStatusForSeriesAtom, ProductsForSeriesAtom } from '../../../store/SeriesStore';
import series from '../../../Components/Dashboard/Series';
import { getMetaDescription } from '../../../utils/seo';

function RenderSelectProduct({ data }) {
    if (!data) {
        return null;
    }

    return <div className='select-product'>
                <SelectProduct product={data} />
            </div>;
}

function RenderAvailable({ data, isNotForSale }) {
    const history = useHistory();

    if (!data) {
        return null;
    }

    return <>
        <div className='product-mobile-available-book-wrapper-mobile'>
            {formTheAssetGroup(data.assetLinkGroups?.reverse())?.map(items => {
                return <KodanshaAvailable items={items}
                                          also={!isNotForSale}
                                          text={items?.some(i => i.name === 'Audio Files') ? 'Extras' : undefined}
                                          scrollTo={((history.location.state as { isScroll: boolean })?.isScroll)} />;
            })}
        </div>

        <div className='product-desktop-available-book-wrapper-desktop'>
            {data.subCategory !== 'Book' &&

                formTheAssetGroup(data.assetLinkGroups?.reverse())?.map(items => {
                    return <KodanshaAvailable items={items}
                                              also={!isNotForSale}
                                              text={items?.some(i => i.name === 'Audio Files') ? 'Extras' : undefined}
                                              scrollTo={((history.location.state as { isScroll: boolean })?.isScroll)} />;
                })}
        </div>

    </>;
}

function RenderBreadCrumb({ data }) {
    if (!data) {
        return null;
    }

    return <>

        <div className='product-hide-breadcrumb-on-desktop'>
            <KodanshaBreadCrumb
                firstNoMargin
                items={data.volumeNumber ? ['browse', data.subCategory === 'Book' ? 'book' : 'manga', data.series?.title]
                    : ['browse', data.subCategory === 'Book' ? 'book' : 'manga']}
                links={['/browse', data.subCategory === 'Book' ? '/browse/book' : '/browse/manga', '/series/' + (data.series?.readableUrl ?? data.series?.id)]} />
        </div>

        <div className='product-hide-breadcrumb-on-mobile'>
            <KodanshaBreadCrumb
                items={data.volumeNumber ? ['browse', data.subCategory === 'Book' ? 'book' : 'manga', data.series?.title, data.volumeNumber?.toString()]
                    : ['browse', data.subCategory === 'Book' ? 'book' : 'manga', data.series?.title]}
                links={['/browse', data.subCategory === 'Book' ? '/browse/book' : '/browse/manga', '/series/' + (data.series?.readableUrl ?? data.series?.id)]} />
        </div>
    </>;
}


interface KodanshaProductParams {
    pid: string;
}

const KodanshaProduct = ({}): ReactElement => {
    const { pid } = useParams<KodanshaProductParams>();
    const [loginStatus] = useAtom(LoginStatusAtom);
    const history = useHistory();
    const [notFound, setNotFound] = useState(false);
    const accountInfo = useAtomValue(AccountInfoAtom);

    function trackView(data) {
        ReactGA.send({ hitType: 'pageview', page: window.location.href, title: 'Product | ' + data.name });
    }

    Log.debug('pidd', pid);
    const {
        data,
        loading,
        fetch,
        error,
    } = useLazyFetch<Product>(() =>
        apiClient.getProductById(pid, null, 600), true);

    const {
        isNotForSale: isNotForSaleTemp,
    } = usePurchasedType(data, data?.id);
    const isNotForSale = isNotForSaleTemp || data?.subCategory === 'Book';

    // const [volumes, setVolumes] = useState<Product[]>(null);

    useEffect(() => {
        if(loginStatus === "LoggedIn" || loginStatus === "LoggedOut") {
            fetch();
        }
    }, [pid, loginStatus]);
    useEffect(() => {
        if (error) {
            console.log(error);
            setNotFound(true);
        }
    }, [error]);

    useEffect(() => {
        if (data?.readableUrl && data.id.toString() === pid){
            history.replace("/product/"+ data.readableUrl);
        }
    }, [data, pid]);

    Log.info("Render Product...");
    if (notFound) {
        return (<KodanshaNotFound />);
    }

    if (loading) {
        return (<>
            <KodanshaNavbar />
            <div className='product-container'>
                <div className='product-name-poster-wrapper'>
                    {/* Mobile */}
                    <div className='product-container-mobile'>
                        <div className='product-poster-wrapper'>
                            <ProductPoster hover={false} src={''} alt={'Loading...'} isOnSale={true} isProductPage={true}/>
                        </div>
                        <div className='product-breadcrumb-wrapper' data-nosnippet={true}>
                            <KodanshaBreadCrumb
                                items={['Browse', 'Manga']}
                                links={['']} />
                        </div>
                        <h1 className='product-title'></h1>
                        <div className='product-rating-wrapper'>
                            <Rating readable={data?.readable} ageRating={data?.ageRating} trim={data?.trim} />
                        </div>
                    </div>
                    {/* End Mobile */}

                    {/* Desktop */}
                    <div className='product-container-desktop'>
                        <DesktopHeader isProduct={true} />
                        <div className='product-desktop-rating-wrapper'>
                                <span
                                    className='product-desktop-rating-title'>{data?.subCategory === 'Book' ? 'Book' : 'Volume'} Info</span>
                            <DesktopRating readable={undefined} ageRating={undefined} trim={data?.trim} />
                        </div>
                    </div>
                    {/* End Desktop */}
                </div>
            </div>
            <KodanshaFooter />
        </>);
    }

    if (data === undefined || data === null) {
        return null;
    }


    const richDataObj: StructuredDataProps = {
        type: 'Product',
        name: data?.name,
        images: data?.thumbnails.map(t => {
            return t.url;
        }),
        description: data?.description,
        sku: data?.readable.eisbn,
        mpn: data?.readable.eisbn,
        brand: {
            '@type': 'Brand',
            name: 'Kodansha',
        },
    };

    if (data?.variants.filter(v => v.type == VariantType.Digital && v.priceType === 'Paid').length > 0) {
        richDataObj['digitalProduct'] = [{
            '@type': 'Offer',
            priceCurrency: 'USD',
            price: data?.variants.filter(v => v.type == VariantType.Digital)[0]?.fullPrice ?? 0,
            itemCondition: 'https://schema.org/NewCondition',
            availability: 'https://schema.org/InStock',
        }];
    }


    return (
        <>
            <Helmet>
                {/*Basic SEO Tags*/}
                <title>{data?.name ?? 'Kodansha – Inspire Impossible Stories'}</title>
                <meta name='description' content={getMetaDescription(data?.metaDescription, data?.description)} />
                {data?.readableUrl && (
                    <link rel='canonical'
                          href={'/product/' + data.readableUrl + '/'} />
                )}

                {/*OpenGraph*/}
                <meta property='og:title' content={data?.name} />
                <meta property='og:type' content='Book' />
                <meta property='og:description' content={data?.description} />
                <meta property='og:site_name' content='Kodansha' />
                <meta property='og:locale' content='en-GB' />
                <meta property='og:image' content={data?.thumbnails[0]?.url} />

                {/* Twitter (https://developer.twitter.com/en/docs/twitter-for-websites/cards/guides/getting-started) */}
                <meta name='twitter:card' content='summary' />
                <meta name='twitter:site' content='@KodanshaManga' />
                <meta name='twitter:title' content={data?.name} />
                <meta name='twitter:description' content={data?.description} />
                <meta name='twitter:image:src' content={data?.thumbnails[0]?.url} />
                <meta name='twitter:image:alt' content={'Image from ' + data?.name} />
                <meta name='twitter:domain' content='Kodansha' />

                {/* OpenData */}
                {
                    data?.variants.filter(v => v.type == VariantType.Digital && v.priceType === 'Paid').length > 0 &&
                    StructuredData(richDataObj)
                }
            </Helmet>
            <KodanshaNavbar />

            <div className='product-container'>
                <div className='product-name-poster-wrapper'>
                    <div className='name-author-wrapper-product'>


                        <h1 className='product-title'>
                            {data.name}
                        </h1>

                        {data?.creators.length > 0 && <span className='series-desktop-header-info-author'>
                            By {(data.creators && mapCreators(data.creators)) ?? ''}
                        </span>}


                        {accountInfo.roles?.find(x => x.toLowerCase() == 'admin') ?
                            <div className={'product-admin-edit'}>
                                <Link to={'/dashboard/products/' + data.id} className='edit-product-for-admin'>
                                    <FontAwesomeIcon icon={faEdit} size='2x' />
                                    <span>
                                Edit Product
                            </span>
                                </Link>
                                {/*//TODO: READER uses readable url*/}
                                <Link to={{
                                    pathname: readerReadableUrlOrDefault(data),
                                    state: { returnPath: history.location.pathname },
                                }}
                                      className='edit-product-for-admin'>
                            <span>
                                Reader
                            </span>
                                </Link>
                            </div>
                            : null}
                        {accountInfo.roles?.find(x => x.toLowerCase() == 'staff') ?
                            <div className={'product-admin-edit'}>

                                <Link to={{
                                    pathname: readerReadableUrlOrDefault(data),
                                    state: { returnPath: history.location.pathname },
                                }}>
                                <span>
                                 Reader
                            </span>
                                </Link>
                            </div> : null
                        }


                        <p className='series-desktop-header-info-description'
                           dangerouslySetInnerHTML={{ __html: data.description }} />


                        <div className='series-desktop-header-available-book-wrapper'>
                            {data?.subCategory === 'Book' && formTheAssetGroup(data?.assetLinkGroups)?.map(items => {
                                return <KodanshaAvailable items={items}
                                                          also={!isNotForSale}
                                                          text={items?.some(i => i.name === 'Audio Files') ? 'Extras' : undefined}
                                                          scrollTo={((history.location.state as {
                                                              isScroll: boolean
                                                          })?.isScroll)} />;
                            })}
                        </div>
                    </div>
                    <div className='product-container-mobile'>
                        <div className='product-poster-wrapper'>
                            <ProductPoster
                                hover={false}
                                src={data.thumbnails[0].url}
                                preloadImage={true}
                                alt={'cover for ' + data.name}
                                isOnSale={data.variants[0]?.isOnSale}
                                isProductPage={true}
                                s={{ width: 500 }}
                                m={{ width: 700 }}
                                l={{ width: 1000 }}
                                xl={{ width: 1200 }}
                            />
                        </div>
                    </div>
                    <div className='product-container-desktop'>
                        <div className='product-poster-wrapper'>
                            <ProductPoster
                                hover={false}
                                src={data.thumbnails[0].url}
                                preloadImage={true}
                                alt={'cover for ' + data.name}
                                isOnSale={data.variants[0]?.isOnSale}
                                isProductPage={true}
                            />
                        </div>
                    </div>
                    <div className='product-breadcrumb-wrapper' data-nosnippet={true}>
                        <RenderBreadCrumb data={data} />
                    </div>
                </div>

                <div className='product-rating-wrapper'>
                    <SynopsisTab synopsisText={data.description} readable={data.readable}
                                 ageRating={data.ageRating} trim={data.trim} />
                </div>

                <div className='product-desktop-rating-wrapper'>
                            <span
                                className='product-desktop-rating-title'>{data.subCategory === 'Book' ? 'Book' : 'Volume'} Info</span>
                    <DesktopRating readable={data.readable} ageRating={data.ageRating} trim={data.trim} />
                </div>

                <RenderSelectProduct data={data} />

                <RenderAvailable data={data} isNotForSale={isNotForSale} />

                <BrowseManga title={'Browse all our Manga'} />

            </div>

            {trackView(data)}
            <SeriesForProductNavigator productId={data.id} seriesId={data.series?.id} />
            <KodanshaSubscription />
            <KodanshaFooter />
        </>

    );
};

interface VolumesForSeriesWheelProps {
    productId: number;
    seriesId: number;
}

function SeriesForProductNavigator({ productId, seriesId }: VolumesForSeriesWheelProps) {
    const [finalSeries, fetchSeries] = useAtom(FetchSingleSeriesAtom);
    const volumes = useAtomValue(ProductsForSeriesAtom);
    const loginStatus = useAtomValue(LoginStatusAtom);
    const [lastLoginStatus, setLastLoginStatus] = useAtom(LoginStatusForSeriesAtom);

    useEffect(() => {
        Log.info(`Series trigger: sid ${seriesId}, loginStatus: ${loginStatus} vs prev sid ${finalSeries?.id}, loginStatus ${lastLoginStatus}`);
        if ((loginStatus === 'LoggedIn' || loginStatus === 'LoggedOut') && seriesId) {
            if (finalSeries?.id !== seriesId || loginStatus !== lastLoginStatus) {
                fetchSeries(seriesId.toString()).then(() => {
                    setLastLoginStatus(loginStatus);
                });
            }
        }
    }, [seriesId, loginStatus]);

    if (seriesId && volumes && volumes.length > 1) {
        const lengthOfData = volumes?.length;
        const positionInData = volumes?.findIndex(product => product.id === productId);
        return (
            <>
                <div className={'volume-direct-container'}>
                    {positionInData - 1 >= 0 ?
                        <VolumeDirect product={volumes[positionInData - 1]} type={'Previous'} /> : <div />}
                    {positionInData + 1 < lengthOfData ?
                        <VolumeDirect product={volumes[positionInData + 1]} type={'Next'} /> : <div />}
                </div>
                <div className={'volume-wheels-margin-container'}>
                    <VolumesWheel volumes={volumes} title={'Explore the full series'} currentVolume={productId}
                                  currentIndex={positionInData}
                                  series={finalSeries}
                                  useCTA={true} />
                </div>
            </>
        );
    }

    return null;
}

export default KodanshaProduct;
